export const TASK_DRAWER_QUERY_KEY = 'taskID'
export const TASK_DEPARTMENT_DRAWER_QUERY_KEY = 'depID'
